import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { TeaserComponent } from '../../molecules/teaser/teaser.component';
import { CommonModule } from '@angular/common';
import TeaserType from '../../../shared/enums/teaser.type.enums';
import { Colors, Headlines, Sizes } from '../../../shared/enums/shared.enums';
import BadgeType from '../../../shared/enums/badge-type.enums';
import { News } from '../../../shared/interfaces/news.interface';
import { TeaserShowcaseType } from '../../../shared/enums/teaser-showcase-type.enums';
import { Teaser } from '../../../shared/interfaces/teaser.interface';
import { ImageMetaData } from '../../../shared/interfaces/meta-data.interface';
import { ImagesService } from '../../../services/images.service';
import { CapitalizePipe } from '../../capitalize.pipe';
import { CaasBodytextService } from '../../../services/caas-bodytext.service';
import { HrefType } from '../../../shared/enums/href-type.enums';
import LinkType from '../../../shared/enums/link-type.enums';
import { TeaserContainerComponent } from '../teaser-container/teaser-container.component';
@Component({
  selector: 'hdi-dynamic-teaser-showcase',
  standalone: true,
  imports: [
    CommonModule,
    TeaserComponent,
    CapitalizePipe,
    TeaserContainerComponent,
  ],
  templateUrl: './dynamic-teaser-showcase.component.html',
  styleUrls: ['./dynamic-teaser-showcase.component.scss'],
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class DynamicTeaserShowcaseComponent implements OnChanges {
  @Input() news: News[];
  @Input() teasers: Teaser[];
  @Input() type: TeaserShowcaseType = TeaserShowcaseType.NEWS;
  @Input() imagesMetaData?: ImageMetaData[];
  @ViewChild('teasersOverview') teasersOverview!: TeaserContainerComponent;
  public showNewsContainer: boolean = true;
  public showOldNewsContainer: boolean = true;

  public readonly TeaserShowcaseType = TeaserShowcaseType;
  public readonly HrefType = HrefType;
  public readonly LinkType = LinkType;
  constructor(
    private imagesService: ImagesService,
    private caasBodytextService: CaasBodytextService
  ) {
    this.news = [];
    this.teasers = [];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['imagesMetaData']) {
      this.imagesService.setImagesMetaData(
        changes['imagesMetaData'].currentValue
      );
    }
    if (changes['news']) {
      this.showOldNewsContainer = false;
      setTimeout(() => {
        this.showOldNewsContainer = true;
      }, 100);
      this.news.forEach((news) => {
        news.imageAlt =
          this.imagesService.getAltTextById(news.imageIdentifier) ?? '';
        if (news.rawLink) {
          news.link = {
            href: this.caasBodytextService.getHref(news.rawLink),
            hrefType: this.caasBodytextService.getHrefType(news.rawLink),
            title: news.rawLink?.value?.formData?.lt_link_title?.value ?? '',
            label: news.rawLink?.value?.formData?.lt_link_label?.value ?? '',
            linkType: this.caasBodytextService.checkOptionalLinksType(
              news.rawLink
            ),
          };
        }
      });
      if (this.teasersOverview) {
        this.teasersOverview.initializeVisibleTeasers(
          changes['news'].currentValue
        );
      }
    }
  }

  TeaserType = TeaserType;
  Colors = Colors;
  BadgeType = BadgeType;
  Headlines = Headlines;
  Sizes = Sizes;
}
